export const PosFieldNameMapType = {
  Item: 0,
  Modifier: 1,
  Discount: 2,
  ServiceCharge: 3,
} as const;

export type PosFieldNameMapType = (typeof PosFieldNameMapType)[keyof typeof PosFieldNameMapType];
